// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__krkfe","summary":"style_summary__VOco_","subtitle":"style_subtitle__g2E6P","seeAll":"style_see-all__50xrl","video":"style_video__9txf5"};